import { CustomFormControl } from 'digital-core';
import { ADPResourceService as ResourceService } from 'digital-core';

export class NumericValidator {
  constructor(public resourceService: ResourceService) {}

  isNumberValid(component: CustomFormControl) {
    if (!component.value) {
      return;
    }

    const value = component.value;

    const numberMatch = value.match(/^[0-9]*$/);

    if (numberMatch && numberMatch.length > 0) {
      return null;
    } else {
      return { validateNumber: { valid: false } };
    }
  }
}
